__webpack_require__.p =function setMFPublicPath() {
    const src = document.currentScript.src;
    return `${src}/../`;
}('BoLegacyApp', 'BoLegacyApp');